import React from 'react';
import PropTypes from 'prop-types';
import categoryHelper from 'helpers/category';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Input from './phase/form/Input';
import Prices from './phase/form/Prices';

class BookingsAmendForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.systemLanguage = navigator.language.split('-')[0];
    }

    componentDidMount() {
        const {
            data,
        } = this.props;

        if (!utils.isEmpty(data)) {
            this.handleInitialize();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            data,
        } = this.props;

        if (utils.get(prevProps.data, 'id') !== utils.get(data, 'id')) {
            this.handleInitialize(data);
        }
    }

    handleInitialize = () => {
        const {
            categoryId,
            data,
            initialize,
        } = this.props;

        let values = {
            destination_arrival_date: data.destination_arrival_date,
        };

        switch (categoryId) {
            case categoryHelper.getCategoryHubId():
            case categoryHelper.getCategoryBikeId():
            case categoryHelper.getCategoryParkingId():
                values = utils.pick(data, [
                    'destination_arrival_date',
                    'destination_departure_date',
                ]);
                break;
            case categoryHelper.getCategoryTaxiId():
            case categoryHelper.getCategoryTransferId():
                values = utils.pick(data, [
                    'destination_arrival_date',
                    'origin_address',
                    'destination_address',
                ]);
                break;
            default:
                break;
        }

        if (data.number_of_persons) {
            values.number_of_persons = data.number_of_persons;
        }

        return initialize(values);
    }

    render() {
        const {
            categoryId,
            prices,
        } = this.props;

        return (
            <form>
                <Input categoryId={ categoryId } />

                { !utils.isEmpty(prices) &&
                    <Prices
                        prices={ prices }
                    />
                }
            </form>
        );
    }
}

BookingsAmendForm.contextTypes = {
    config: PropTypes.object,
};

BookingsAmendForm.propTypes = {
    data: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    categoryId: PropTypes.number,
    prices: PropTypes.shape({
        price: PropTypes.number,
        currency: PropTypes.string,
    }),
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(BookingsAmendForm);



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/BookingAmendForm.js